<!-- This component is based on https://ob1.orange.fr/#example/code-promotionnel.html -->

<template>
  <form>
    <promotional-code-form
      v-if="currentState === STATE.CODE"
      key="1"
      :input-label="wording.addPromotionalCodeLabel"
      :add-button-label="wording.addButton"
      :dark-mode="darkMode"
      :error-message="currentErrorMessage"
      @add="onAddCode"
      @clear-error="onClearError" />
    <promotional-code-form
      v-else-if="currentState === STATE.CUID"
      key="2"
      :info-message="wording.requiredCuidAlertInfo"
      :input-label="wording.addCuidLabel"
      :add-button-label="wording.addButton"
      :dark-mode="darkMode"
      :error-message="currentErrorMessage"
      @add="onAddCuid"
      @clear-error="onClearError" />
    <promotional-code-success
      v-else-if="currentState === STATE.SUCCESS"
      :message="wording.successLabel"
      :cancel-button-label="wording.cancelButton"
      :dark-mode="darkMode"
      @cancel="onCancel" />
  </form>
</template>

<script>
import PromotionalCodeSuccess from './promotionalCodeSuccess/PromotionalCodeSuccess'
import PromotionalCodeForm from './promotionalCodeForm/PromotionalCodeForm'

const STATE = {
  CODE: 'code',
  CUID: 'cuid',
  SUCCESS: 'success'
}

const defaultWording = {
  addButton: 'Ajouter',
  cancelButton: 'Annuler',
  addPromotionalCodeLabel: 'Ajouter un code promotionnel',
  invalidCodeLabel: 'Ce code n\'est pas valide',
  successLabel: 'Votre remise est appliquée',
  addCuidLabel: 'Ajouter votre identifiant salarié',
  requiredCuidAlertInfo: 'Vous avez ajouté un code promotionnel destiné aux salariés Orange.\n' +
                         'Pour le valider, veuillez ajouter votre identifiant salarié.',
  invalidCuidLabel: 'Cet identifiant n\'est pas valide',
  helperText: null
}

export default {
  name: 'WptvPromotionalCode',
  components: {
    PromotionalCodeSuccess,
    PromotionalCodeForm
  },
  props: {
    darkMode: {
      type: Boolean,
      default: false
    },
    customWording: {
      type: Object,
      default: () => {}
    },
    addCodeCb: {
      type: Function,
      required: true
    },
    addCuidCb: {
      type: Function,
      default: () => {}
    },
    cancelCb: {
      type: Function,
      required: true
    },
    showSuccess: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      currentState: STATE.CODE,
      currentErrorMessage: null,
      STATE
    }
  },
  computed: {
    errorMessage () {
      return this.currentErrorMessage ? this.currentErrorMessage : this.wording.invalidCodeLabel
    },
    wording () {
      // merge default wording and custom one
      return {
        ...defaultWording,
        ...this.customWording
      }
    }
  },
  mounted () {
    if (this.showSuccess) {
      this.currentState = STATE.SUCCESS
    }
  },
  methods: {
    onAddCode (inputValue) {
      this.addCodeCb(inputValue)
        .then((param) => {
          if (param?.cuidRequired) {
            this.currentState = STATE.CUID
          } else {
            this.currentState = STATE.SUCCESS
          }
        })
        .catch((errorMessage) => {
          this.currentErrorMessage = errorMessage || this.wording.invalidCodeLabel
        })
    },
    onAddCuid (inputValue) {
      this.addCuidCb(inputValue)
        .then(() => {
          this.currentState = STATE.SUCCESS
        })
        .catch((errorMessage) => {
          this.currentErrorMessage = errorMessage || this.wording.invalidCuidLabel
        })
    },
    onCancel () {
      this.cancelCb()
        .then(() => {
          this.currentState = STATE.CODE
        })
    },
    onClearError () {
      this.currentErrorMessage = null
    }
  }
}
</script>

<style lang="scss">
@import '../../scss/abstracts/variables';

</style>
